<div class="client-row">
  <div class="release-cell">
    <i class="component-icon square-icon fa-duotone fa-solid fa-code-branch"></i>
    <div class="d-flex flex-column justify-content-center g-g">
      <span class="release-name">{{ release.name }}</span>
      <span>{{ release.releaseDate | date:'yyyy-MM-dd' }}</span>
    </div>
  </div>
  <div class="components-wrapper">
    <div class="component">
      <i class="component-icon square-icon fa-duotone fa-solid fa-chart-network"></i>
      <div class="component-info-wrapper">
        <div class="d-flex g-g">
          <span class="fw-bold">CN5G</span>
          @if (release.name && release.cn5g && release.cn5g.storageUrl) {
            <button type="button" class="download-button" (click)="downloadReleaseZipFile(release.name, 'cn5g', release.cn5g.storageUrl)">
              <i class="fa-solid fa-download"></i>
            </button>
          }
          </div>
        <span>{{ release.cn5g?.tagName ?? '--' }}</span>
      </div>
    </div>

    <div class="component">
      <i class="component-icon square-icon fa-duotone fa-solid fa-brain-circuit"></i>
      <div class="component-info-wrapper">
        <div class="d-flex g-g">
          <span class="fw-bold">FlexRIC</span>
          @if (release.name && release.flexric && release.flexric.storageUrl) {
            <button type="button" class="download-button" (click)="downloadReleaseZipFile(release.name, 'flexric', release.flexric.storageUrl)">
              <i class="fa-solid fa-download"></i>
            </button>
          }
        </div>
        <span>{{ release.flexric?.tagName ?? '--' }}</span>
      </div>
    </div>

    <div class="component">
      <i class="component-icon square-icon fa-duotone fa-solid fa-tower-broadcast"></i>
      <div class="component-info-wrapper">
        <div class="d-flex g-g">
          <span class="fw-bold">gNB</span>
          @if (release.name && release.gnb && release.gnb.storageUrl) {
            <button type="button" class="download-button" (click)="downloadReleaseZipFile(release.name, 'gnb', release.gnb.storageUrl)">
              <i class="fa-solid fa-download"></i>
            </button>
          }
        </div>
        <span>{{ release.gnb?.tagName ?? '--' }}</span>
      </div>
    </div>
    
    <div class="component">
      <i class="component-icon square-icon fa-duotone fa-solid fa-dharmachakra"></i>
      <div class="component-info-wrapper">
        <div class="d-flex g-g">
          <span class="fw-bold">Orchestration</span>
          @if (release.name && release.orchestration && release.orchestration.storageUrl) {
            <button type="button" class="download-button" (click)="downloadReleaseZipFile(release.name, 'orchestration', release.orchestration.storageUrl)">
              <i class="fa-solid fa-download"></i>
            </button>
          }
        </div>
        <span>{{ release.orchestration?.tagName ?? '--' }}</span>
      </div>
    </div>
  </div>

  <div class="management-buttons-wrapper" [ngStyle]="{ 'display' : displayButtons ? 'inline-flex' : 'none' }">
    <form [formGroup]="releaseIsVisibleForm" class="form-switch">
      <input class="form-check-input" type="checkbox" role="switch"
             [formControl]="releaseIsVisibleForm.controls.isVisible" (change)="saveReleaseIsVisible()">
      <label class="form-label">Visible</label>
    </form>
    <button class="management-button danger" oaiboxBsPopover="Delete Release" trigger="hover"
            container="body" placement="bottom" (click)="deleteRelease()">
      <i class="fa-solid fa-trash"></i>
    </button>
  </div>
</div>
